export const GHOST_SESSION_PAGES = {
    INIT: '/ghost-session',
    EXPIRED: '/ghost-session/expired',
    ENDED: '/ghost-session/ended',
} as const;

export const GHOST_SESSION_QUERY_PARAMS = {
    SESSION_ID: 'sessionId',
    ACCESS_CODE: 'accessCode',
} as const;

export const GHOST_TOKEN_SCOPE = 'GHOST';
